import { Guid, Nillable } from '@web/utils';
import { OrderNumber } from '../../shared/types';
import { BoxQuestionnaireStatus } from '../../shared/enums';
import { PublicBoxQuestionnaireContextOperations } from './public-box-questionnaire-context-operations';

export class PublicBoxQuestionnaireCollectionItem {
  public constructor(
    private readonly data: {
      createdAt: Date;
      endDate: Date;
      id: Guid;
      isShown: boolean;
      logoAlt?: Nillable<string>;
      logoUrl?: Nillable<string>;
      name: string;
      orderId: Guid;
      orderNumber: OrderNumber;
      contextOperations: PublicBoxQuestionnaireContextOperations;
      status: BoxQuestionnaireStatus;
    },
  ) {}

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get endDate(): Date {
    return this.data.endDate;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get isShown(): boolean {
    return this.data.isShown;
  }

  public get logoAlt(): Nillable<string> {
    return this.data.logoAlt;
  }

  public get logoUrl(): Nillable<string> {
    return this.data.logoUrl;
  }

  public get name(): string {
    return this.data.name;
  }

  public get contextOperations(): PublicBoxQuestionnaireContextOperations {
    return this.data.contextOperations;
  }

  public get orderId(): Guid {
    return this.data.orderId;
  }

  public get orderNumber(): OrderNumber {
    return this.data.orderNumber;
  }

  public get status(): BoxQuestionnaireStatus {
    return this.data.status;
  }
}
